/** @jsxImportSource @emotion/react */

import React from 'react';
import navigationIcon from '../../assets/navigation-icon.svg';
import locationButtonStyles from './location-button.styles';

interface LocationButtonProps {
    onClick?: (event: React.MouseEvent | undefined) => void;
}

const LocationButton = (props: LocationButtonProps) => {
    const { onClick } = props;
    return (
        <div onClick={onClick} css={locationButtonStyles.locationButton}>
            <img
                css={locationButtonStyles.locationButtonIcon}
                src={navigationIcon}
                alt="Navigation icon"
            />
        </div>
    );
};

export default LocationButton;
